import { render, staticRenderFns } from "./CreditWarning.vue?vue&type=template&id=7980b6a2&scoped=true&"
var script = {}
import style0 from "./CreditWarning.vue?vue&type=style&index=0&id=7980b6a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7980b6a2",
  null
  
)

export default component.exports